import { LucideProps } from 'lucide-react';

export const Github = (props: LucideProps) => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.9473 0C6.31967 0 0.947266 5.3808 0.947266 12.0204C0.947266 17.3304 4.38527 21.8364 9.15407 23.4252C9.75407 23.5356 9.97247 23.1648 9.97247 22.8456C9.97247 22.5612 9.96287 21.804 9.95687 20.802C6.61847 21.528 5.91407 19.1904 5.91407 19.1904C5.36927 17.8008 4.58207 17.4312 4.58207 17.4312C3.49247 16.6872 4.66487 16.7016 4.66487 16.7016C5.86847 16.7856 6.50207 17.94 6.50207 17.94C7.57247 19.776 9.31126 19.2456 9.99407 18.9384C10.1045 18.162 10.4141 17.6328 10.7573 17.3328C8.09327 17.0292 5.29127 15.9972 5.29127 11.3916C5.29127 10.08 5.75927 9.006 6.52607 8.166C6.40247 7.8624 5.99087 6.6396 6.64367 4.986C6.64367 4.986 7.65167 4.662 9.94367 6.2172C10.9226 5.95022 11.9326 5.81423 12.9473 5.8128C13.9673 5.8176 14.9933 5.9508 15.9521 6.2172C18.2429 4.662 19.2485 4.9848 19.2485 4.9848C19.9037 6.6396 19.4909 7.8624 19.3685 8.166C20.1365 9.006 20.6021 10.08 20.6021 11.3916C20.6021 16.0092 17.7953 17.0256 15.1229 17.3232C15.5537 17.694 15.9365 18.4272 15.9365 19.5492C15.9365 21.1548 15.9221 22.452 15.9221 22.8456C15.9221 23.1672 16.1381 23.5416 16.7477 23.424C19.1372 22.6225 21.2145 21.0904 22.6858 19.0441C24.1572 16.9977 24.9483 14.5408 24.9473 12.0204C24.9473 5.3808 19.5737 0 12.9473 0Z"
      fill="currentColor"
    />
  </svg>
);
